import Vue from 'vue'
import 'jquery-mousewheel'
import App from './App.vue'
import router from './router'
import store from './store'; // 引入 Vuex
// import 'lib-flexible'
import 'postcss-pxtorem'
// import 'amfe-flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/rem'
import '@/assets/styles/global.css';
import { myMessage } from './utils/resetMessage.js'; // 引入重置的 message
import dayjs from 'dayjs';
import i18n from './i18n';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import eventBus from '@/eventBus';

// 注册全局过滤器
Vue.filter('formatDate', (value, format = 'YYYY-MM-DD') => {
  if (!value) return '';
  return dayjs(value).format(format);
});

// 注册全局方法
Vue.prototype.$dayjs = dayjs;

// 初始化Element UI语言
const initElementLocale = () => {
  const elementLocale = i18n.locale === 'en' ? enLocale : zhLocale;
  locale.use(elementLocale);
};

// 初始化时设置一次
initElementLocale();

// 监听i18n语言变化，动态更新Element UI语言
eventBus.$on('localeChanged', () => {
  initElementLocale();
});

Vue.use(ElementUI);

Vue.prototype.$message = myMessage ;
Vue.config.productionTip = false

// window.addEventListener('resize', () => {
//   const width = document.innerWidth
//   if (width > 1200) {
//     document.documentElement.style.fontSize = '100px'; // 可以根据实际情况设置固定值
//   }
// })

new Vue({
  i18n,
  router,
  store, // 注入 Vuex
  render: h => h(App)
}).$mount('#app')